import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'

class SidebarLink extends Component {

  static propTypes = {
    className: PropTypes.string,
    linkUrl : PropTypes.string.isRequired,
    iconClass : PropTypes.string.isRequired,
    linkTitle : PropTypes.string.isRequired,
  };

  render() {
    const {
      className,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

    const handlers = {
      onClick: this.onClick,
    };

    return (
          <li className= { this.props.listClass }>
              <Link to={this.props.linkUrl}
                className={className}
                {...handlers}
              >
                  <i className={this.props.iconClass}></i>
                  <span className="title">{this.props.linkTitle}</span>
                  <span className="arrow "></span>
              </Link>
          </li>
    );
  }
}

export default SidebarLink;
